import api from '../api';

export function container() {
    return {
        api,
    }
}



// WEBPACK FOOTER //
// ./src/utils/container.js